import {
  EXTERNCALL_REST,
  DEALERS_BY_CAR,
  STEP_INCREMENT,
  CLEAR_HOUR,
  UPDATE_USER,
  DEALERS_INFO,
  IS_REQUESTING,
  REQUESTING_END,
  STEP_DIRECT,
  CAR_INFO,
  TIME_INFO,
  ERROR_STATE,
  APPOINTMENT
} from "./types";
import $ from "jquery";
import { push } from "react-router-redux";



export const appointementInit = (url, data, name) => {
  return (dispatch) => {
    console.log('ici')
    dispatch({ type: IS_REQUESTING });
    $.ajax({
      url: "https://seat.espacerendezvous.com/espaceRdvServer/ws/" + url,
      dataType: "text",
      data: data,
      cache: false,
      async: true,
      scriptCharset: "utf-8",
      xhrFields: {
        withCredentials: true
      },
      type: "post",
      success: function(data) {
        //dispatch({type:REQUESTING_END})
        dispatch({
          type: EXTERNCALL_REST,
          name: name,
          data: data
        });
        if(url === "GetServicesInformations"){
          //dispatch({ type: IS_REQUESTING });    
          dispatch( push('/Module') )
          dispatch({
            type: STEP_DIRECT,
            data: 0
          })
          
        }
        if(url === "CustomerCardFieldList"){
          dispatch({
            type: STEP_INCREMENT
          })
        }
        
      },
      error: function(jqXHR, textStatus, errorThrown) {
        if(textStatus!=="401"){
          dispatch({
            type: ERROR_STATE,
            data: true,
            title: 'Un problème est survenu',
            message: 'error : '+ textStatus
          });
        }
      },
      complete: function(jqXHR, textStatus) {
        dispatch({ type: REQUESTING_END });
      }
    });
  };
};

function makeid() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
}

export const appointementSave = (id) => {
  return (dispatch, getState) => {

    dispatch({ type: IS_REQUESTING });

    var dataobject = {
      locale: "fr",
      slotId: id,
      proAccountCustomerCardFieldList: JSON.stringify(getState().restIntel.intel.user)
    };

    dataobject.proId = getState().restIntel.intel.dealerInfo.id;
    dataobject.wlName = "seat";
    //dataobject.lead_id = makeid();
    dataobject.lead_id = getState().lead.idLead;
    dataobject.origin = "api_erdv";
    dataobject.note = getState().inquires.home.type;
    dataobject.pro_name = "erdv";

    console.log(dataobject.lead_id);
    $.ajax({
      url: "https://seat.espacerendezvous.com/espaceRdvServer/ws/SaveCustomerAppointment",
      dataType: "json",
      data: dataobject,
      cache: false,
      type: "post",
      scriptCharset: "utf-8",
      xhrFields: {
        withCredentials: true
      },
      success: function(data) {
        if(data['reference']){
          dispatch({
            type: APPOINTMENT,
            data: data
          })
          dispatch({
            type: STEP_INCREMENT
          })
        }else{
          dispatch({
            type: ERROR_STATE,
            data: true,
            title: 'Un problème est survenu',
            message: 'error : '+ data
          });
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        dispatch({
          type: ERROR_STATE,
          data: true,
          title: 'Un problème est survenu',
          message: 'error : '+ textStatus
        });
      },
      complete: function(jqXHR, textStatus) {
        dispatch({ type: REQUESTING_END });
        // console.log(jqXHR);
        // console.log(textStatus);
      }
    });
  };
};

export const appointementClearHours = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_HOUR
    });
  };
};

export const appointementUser = data => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_USER,
      data: data
    });
    dispatch({
      type: STEP_INCREMENT
    });
  };
};

export const dealerInfo = data => {
  return (dispatch) => {
    dispatch({
      type: DEALERS_INFO,
      data: data
    });
    dispatch({
      type: STEP_INCREMENT
    });
  };
};
export const carInfo = data => {
  return (dispatch) => {
    dispatch({
      type: CAR_INFO,
      data: data
    });
  };
};
export const timeInfo = data => {
  return (dispatch) => {
    dispatch({
      type: TIME_INFO,
      data: data
    });
  };
};

export const appointementDealersByCar = index => {
  return (dispatch, getState) => {
    dispatch({
      type: DEALERS_BY_CAR,
      data: getState().restIntel.intel.dealers[index].comptes
    });
    dispatch({
      type: STEP_INCREMENT
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/appointement.js